// ITER287 — Presentational item card, reused by GuestMenu (public).
// Pure display component. Owns no state. Future Add-to-Cart / modifier
// picker can wrap this without touching the guest page layout.
//
// Props:
//   item      : parsed_data item (name, description, price_display, veg,
//               chef_recommend, bestseller, available, ...)
//   theme     : { primary, secondary, background } from outlet theme.
//   testId    : data-testid override (defaults to `dish-{item.id}`).
//   trailing  : optional slot (right-side node) — reserved for future
//               cart controls. Kept undefined for now.
//   VegDot    : passed in from the parent so we don't create a circular
//               dependency with the admin page's shared VegDot export.
import React from 'react';

export function MenuItemCard({ item, theme, testId, trailing, VegDot }) {
  const soldOut = item.available === false;
  return (
    <li
      className={`py-4 flex items-start justify-between gap-4 ${
        soldOut ? 'opacity-60' : ''
      }`}
      data-testid={testId || `dish-${item.id}`}
      data-item-id={item.id}
    >
      <div className="min-w-0 flex-1">
        <div className="flex items-center gap-2 flex-wrap">
          <span
            className={`font-medium ${soldOut ? 'line-through' : ''}`}
            style={{ color: theme.primary }}
            data-testid={`dish-name-${item.id}`}
          >
            {item.name}
          </span>
          {VegDot && <VegDot type={item.veg} />}
          {item.chef_recommend && (
            <span
              className="text-[10px] px-1.5 rounded-full font-medium"
              style={{
                background: `${theme.secondary}22`,
                color: theme.secondary,
              }}
              data-testid={`chef-pick-${item.id}`}
            >
              CHEF&apos;S PICK
            </span>
          )}
          {item.bestseller && (
            <span
              className="text-[10px] px-1.5 rounded-full font-medium uppercase tracking-wider"
              style={{
                background: '#DC26261A',
                color: '#B91C1C',
              }}
              data-testid={`bestseller-${item.id}`}
            >
              Bestseller
            </span>
          )}
          {soldOut && (
            <span
              className="text-[10px] px-1.5 rounded-full font-medium uppercase tracking-wider bg-rose-100 text-rose-700"
              data-testid={`sold-out-${item.id}`}
            >
              Sold Out
            </span>
          )}
        </div>
        {item.subcategory && (
          <div className="text-[10px] uppercase tracking-wider text-gray-400 mt-1">
            {item.subcategory}
          </div>
        )}
        {item.description && (
          <div className="text-xs text-gray-600 mt-1 leading-snug">
            {item.description}
          </div>
        )}
      </div>
      <div className="flex items-start gap-3 shrink-0">
        <div
          className="font-medium text-sm"
          style={{ color: theme.primary }}
          data-testid={`dish-price-${item.id}`}
        >
          {item.price_display || (item.price ? `₹${item.price}` : '')}
        </div>
        {trailing}
      </div>
    </li>
  );
}

export default MenuItemCard;
